import createIcon from '../../createIcon';

/**
 * @component @name Coffee
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNSAzSDVDMy45IDMgMyAzLjkgMyA1VjEwLjcxQzMgMTQuNTQgNS45NSAxNy44OSA5Ljc4IDE4QzEzLjc0IDE4LjEyIDE3IDE0Ljk0IDE3IDExVjEwSDE3LjVDMTkuNDMgMTAgMjEgOC40MyAyMSA2LjVDMjEgNC41NyAxOS40MyAzIDE3LjUgM1pNMTUgNVY4SDVWNUgxNVpNMTcuNSA4SDE3VjVIMTcuNUMxOC4zMyA1IDE5IDUuNjcgMTkgNi41QzE5IDcuMzMgMTguMzMgOCAxNy41IDhaTTMgMTlIMTlWMjFIM1YxOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Coffee = createIcon('Coffee', [
  [
    'path',
    {
      d: 'M17.5 3H5C3.9 3 3 3.9 3 5V10.71C3 14.54 5.95 17.89 9.78 18C13.74 18.12 17 14.94 17 11V10H17.5C19.43 10 21 8.43 21 6.5C21 4.57 19.43 3 17.5 3ZM15 5V8H5V5H15ZM17.5 8H17V5H17.5C18.33 5 19 5.67 19 6.5C19 7.33 18.33 8 17.5 8ZM3 19H19V21H3V19Z',
      key: '1fw0ty',
    },
  ],
]);

export default Coffee;
